(() => {
const priceText = node => {
if (!node) return '';
const copy = node.cloneNode(true);
copy.querySelectorAll('.visually-hidden').forEach(label => label.remove());
return copy.textContent.replace(/\s+/g, ' ').trim();
};
function moneyParts(value) {
const match = value.match(/-?\d[\d\s.,'’]*/);
if (!match) return null;
const raw = match[0].trim();
const decimal = raw.match(/([.,])(\d{1,2})$/);
const integer = decimal ? raw.slice(0, -decimal[0].length) : raw;
const amount = Number(integer.replace(/[^\d-]/g, '') + (decimal ? '.' + decimal[2] : ''));
if (!Number.isFinite(amount)) return null;
return { amount, raw, index: match.index, decimal: decimal?.[1] || '', places: decimal?.[2].length || 0, group: integer.match(/[^\d-]/)?.[0] || '' };
}
function formattedMoney(amount, sample, parts) {
const [integer, fraction] = amount.toFixed(Math.max(2, parts.places)).split('.');
const separator = parts.group || (parts.decimal === ',' ? '.' : ',');
const whole = Math.abs(amount) >= 10000 ? integer.replace(/\B(?=(\d{3})+(?!\d))/g, separator) : integer;
return sample.slice(0, parts.index) + whole + (Number(fraction) ? (parts.decimal || (parts.group === '.' ? ',' : '.')) + fraction : '') + sample.slice(parts.index + parts.raw.length);
}
window.JoaPriceDisplay = {
add(display, cents) {
if (!display?.current || !cents) return display;
const increase = value => { const parts = moneyParts(value); return parts ? formattedMoney(parts.amount + cents / 100, value, parts) : value; };
return { ...display, current: increase(display.current), compare: display.compare ? increase(display.compare) : '' };
},
read(host) {
if (!host) return null;
const source = host.matches('[data-joa-base-price]') ? host : host.querySelector('[data-joa-base-price]');
const priceRoot = source || host;
const currentNode = priceRoot.querySelector('.price__sale:not(.price__hidden) .price-item--sale, .price__regular .price, .price') || priceRoot;
const rawCurrent = priceText(currentNode) || source?.dataset.joaBasePriceText || '';
const rawParts = moneyParts(rawCurrent);
const current = rawParts ? formattedMoney(rawParts.amount, rawCurrent, rawParts) : rawCurrent;
const parts = moneyParts(current);
if (!current || !parts) return null;
let compare = '';
if (source) {
const base = Number(source.dataset.joaBasePrice);
const original = Number(source.dataset.joaComparePrice);
if (original > base && base > 0) {
const hasOptions = Boolean(host.closest('.product-information')?.querySelector('.mw-option'));
const originalAmount = hasOptions ? parts.amount + (original - base) / 100 : original / 100;
if (originalAmount > parts.amount) compare = formattedMoney(originalAmount, current, parts);
}
} else {
const nativeCompare = priceText(host.querySelector('.compare-at-price'));
const compareParts = moneyParts(nativeCompare);
if (compareParts?.amount > parts.amount) compare = formattedMoney(compareParts.amount, nativeCompare, compareParts);
}
return { current, compare, regularLabel: source?.dataset.joaRegularLabel || '', saleLabel: source?.dataset.joaSaleLabel || '' };
},
render(target, display) {
if (!target || !display?.current) return;
const key = JSON.stringify(display);
const currentNode = target.querySelector('.joa-price-current');
const compareNode = target.querySelector('.joa-price-compare');
if (target.dataset.joaPriceDisplay === key && priceText(currentNode) === display.current && priceText(compareNode) === display.compare) return;
const current = document.createElement('span');
current.className = 'price joa-price-current';
if (display.compare && display.saleLabel) {
const label = document.createElement('span'); label.className = 'visually-hidden'; label.textContent = display.saleLabel + ' '; current.append(label);
}
// Keep the exact price text; only separate the main summary's currency for styling.
const currency = target.matches('.joa-design-summary__price') && target.closest('#MainContent .product-details')
  ? display.current.match(/\b[A-Z]{3}\b/) : null;
if (currency) {
const code = document.createElement('span');
code.className = 'joa-price-currency';
code.textContent = currency[0];
current.append(document.createTextNode(display.current.slice(0, currency.index)), code, document.createTextNode(display.current.slice(currency.index + currency[0].length)));
} else current.append(document.createTextNode(display.current));
target.replaceChildren(current);
if (display.compare) {
const original = document.createElement('s');
original.className = 'compare-at-price joa-price-compare';
if (display.regularLabel) { const label = document.createElement('span'); label.className = 'visually-hidden'; label.textContent = display.regularLabel + ' '; original.append(label); }
original.append(document.createTextNode(display.compare));
target.append(document.createTextNode(' '), original);
}
target.classList.toggle('joa-price-pair', Boolean(display.compare));
target.dataset.joaPriceDisplay = key;
}
};
const configCopy = JSON.parse(document.querySelector('[data-joa-global-option-copy]')?.textContent || '{}');
const configText = key => configCopy[key] || key.replaceAll('_', ' ');
const configSetText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
const configSetAttr = (node, key, value) => { if (node.getAttribute(key) !== String(value)) node.setAttribute(key, String(value)); };
function optionIcon(kind) {
  const paths = {
    diamond: '<path d="m3 8 4-5h10l4 5-9 13L3 8Z M3 8h18 M7 3l5 18 5-18 M7 3l5 5 5-5"/>',
    clarity: '<path d="m10 3 2 6 6 2-6 2-2 6-2-6-6-2 6-2 2-6Z M19 2v4 M17 4h4 M20 17v4 M18 19h4"/>',
    metal: '<ellipse cx="12" cy="6" rx="9" ry="3"/><path d="M3 6v5c0 4 18 4 18 0V6 M3 11v5c0 4 18 4 18 0v-5"/>',
    ring: '<circle cx="12" cy="15" r="7"/><path d="m9 3 3-2 3 2-3 5-3-5Z"/>',
    other: '<path d="M4 6h16M4 12h16M4 18h16"/>',
    engraving: '<path d="m15 4 5 5M4 20l5-1L20 8a2.8 2.8 0 0 0-4-4L5 15l-1 5Z"/>'
  };
  return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths[kind] || paths.other}</svg>`;
}
function approvedPayment(form, display) {
  const root = form?.querySelector('#downpay-block');
  if (!root || !display?.current) return;
  configSetText(root.querySelector('legend'), configText('payment_heading'));
  const full = root.querySelector('#purchase-option-full-wrapper');
  const deposit = root.querySelector('#purchase-option-deposit-wrapper');
  if (full && deposit && deposit.nextElementSibling === full) deposit.before(full);
  for (const [selector, label, note] of [
    ["label[for='purchase-option-full']", configText('full_payment'), configText('payment_full_note')],
    ["label[for='purchase-option-deposit-input']", configText('payment_deposit_choice'), configText('payment_deposit_note')]
  ]) {
    const node = root.querySelector(selector);
    if (!node) continue;
    let content = node.querySelector('.joa-config-payment-copy');
    if (!content) {
      content = document.createElement('span');
      content.className = 'joa-config-payment-copy joa-config-payment-main';
      node.append(content);
    }
    let title = content.querySelector('.joa-payment-choice-title');
    let detail = content.querySelector('.joa-payment-choice-note');
    if (!title || !detail) {
      title = document.createElement('span'); title.className = 'joa-payment-choice-title';
      detail = document.createElement('span'); detail.className = 'joa-payment-choice-note';
      content.replaceChildren(title, detail);
    }
    configSetText(title, label);
    configSetText(detail, note);
  }
  root.classList.add('joa-config-payment', 'joa-payment-segments');
}

function renderSelectionChips(target, selections, native = false) {
  if (!target) return;
  const items = selections.filter(item => item.value);
  const key = JSON.stringify([items, native]);
  if (target.dataset.joaChipKey === key) return;
  target.classList.add('joa-selection-chips');
  target.classList.toggle('joa-selection-chips--native', native);
  target.dataset.joaSelectionValues = JSON.stringify(items.map(({ kind, value }) => native && kind === 'ring'
    ? `${configText('config_ring_size')}: ${/not sure|confirm later/i.test(value) ? configText('config_confirm_later') : value}`
    : value));
  const chips = items.map(({ kind, label, value }) => {
    const chip = document.createElement('span');
    chip.className = 'joa-selection-chip';
    let compact = value;
    let description = `${label}: ${value}`;
    if (kind === 'diamond') compact = value.replace(/(\d)\s+(ctw?)(?=\b)/i, '$1$2');
    if (kind === 'clarity') compact = value.replace(/^(VVS[12]|VS[12]|SI[12]|IF|FL)\s*\/\s*/i, '$1 ');
    if (kind === 'metal') {
      const tone = /platinum|^pt$/i.test(value) ? 'platinum' : /(?:2|two)[\s-]*tone|yellow.*white/i.test(value) ? 'two-tone' : /rose/i.test(value) ? 'rose' : /yellow/i.test(value) ? 'yellow' : /white/i.test(value) ? 'white' : '';
      const purity = value.match(/\b(\d{1,2})\s*k\b/i);
      compact = tone === 'platinum' ? 'Pt' : purity ? `${purity[1]}K` : value;
      if (tone) {
        chip.classList.add('joa-selection-chip--metal');
        chip.dataset.metalTone = tone;
      }
    }
    if (kind === 'ring') {
      const size = value.startsWith(`${label}:`) ? value.slice(label.length + 1).trim() : value;
      const pending = /not sure|confirm later|to confirm|^tbd$/i.test(size) || size === configText('config_confirm_later');
      compact = configText('summary_size').replace('[value]', pending ? configText('summary_tbd') : size);
      description = `${label}: ${size}`;
    }
    chip.dataset.selectionKind = kind;
    chip.title = description;
    const accessible = document.createElement('span');
    accessible.className = 'visually-hidden';
    accessible.textContent = description;
    const visible = document.createElement('span');
    visible.setAttribute('aria-hidden', 'true');
    visible.textContent = compact;
    chip.append(accessible, visible);
    return chip;
  });
  target.replaceChildren(...chips);
  target.dataset.joaChipKey = key;
}

function renderPaymentSummary(summary, display, form, surface, totalLabel) {
  if (!summary || !display?.current) return;
  const parts = moneyParts(display.current);
  if (!parts) return;
  const selected = surface?.querySelector('input[name="selling_plan"]:checked, [data-joa-editor-plan]:checked');
  const downpay = surface?.querySelector('#purchase-option-deposit-input:checked');
  const copy = document.querySelector('[data-joa-global-option-copy]');
  let rate = selected?.value ? Number(selected.dataset.depositRate) : 0;
  if (downpay && copy?.dataset.joaDepositPlan === surface.querySelector('#purchase-option-deposit-wrapper')?.dataset.sellingPlan) rate = Number(copy.dataset.joaDepositRate);
  const total = Math.round(parts.amount * 100);
  const hasDeposit = rate > 0 && rate < 1;
  const stones = form?.querySelector('joa-birthstones');
  const quantity = Math.max(1, Number(form?.querySelector('[name="quantity"]')?.value) || 1);
  const extra = stones ? (stones.extraTotal?.() ?? stones.total?.() ?? 0) * quantity : Number(surface?.dataset.joaBirthstoneTotal) || 0;
  const plan = selected?.value || surface?.querySelector('#purchase-option-deposit-wrapper')?.dataset.sellingPlan;
  const eligible = (surface?.dataset.joaBirthstonePlans || '').split(',').includes(plan);
  const extraDue = stones ? (stones.extraDue?.(rate, plan) ?? stones.due?.(rate, plan) ?? 0) * quantity : eligible ? Math.round(extra * rate) : extra;
  const due = hasDeposit ? Math.round((total - extra) * rate) + extraDue : total;
  const amount = cents => formattedMoney(cents / 100, display.current, parts);
  configSetText(summary.querySelector(':scope > span'), hasDeposit ? configText('payment_due_today') : totalLabel);
  const priceNode = summary.querySelector('.joa-design-summary__price');
  window.JoaPriceDisplay.render(priceNode, hasDeposit ? {...display, current:amount(due), compare:''} : display);
  // Product-page terms follow Add to Cart; quick-add and cart editors keep
  // their existing summary. Amounts use the same deposit calculation above.
  const productDetails = summary.closest('#MainContent .product-details');
  const purchaseButton = productDetails?.querySelector('product-form-component .product-form-buttons add-to-cart-component');
  if (purchaseButton) {
    let terms = productDetails.querySelector('.joa-payment-terms');
    if (hasDeposit) {
      if (!terms) {
        terms = document.createElement('span');
        terms.className = 'joa-payment-terms';
        terms.setAttribute('aria-live', 'polite');
        terms.setAttribute('aria-atomic', 'true');
      }
      // The total already names the currency; avoid repeating its ISO code.
      const balanceAmount = amount(total - due).replace(/\s*\b[A-Z]{3}\b\s*/g, ' ').trim();
      configSetText(terms, configText('payment_product_terms').replace('[total]', display.current).replace('[balance]', balanceAmount));
      if (purchaseButton.nextElementSibling !== terms) purchaseButton.after(terms);
    } else terms?.remove();
    summary.querySelectorAll('.joa-payment-total-note, .joa-payment-balance-note').forEach(note => note.remove());
    return;
  }
  let detail = summary.querySelector('.joa-payment-total-note');
  if (hasDeposit) {
    if (!detail) {
      detail = document.createElement('span'); detail.className = 'joa-payment-total-note';
      summary.querySelector('.joa-design-summary__options').before(detail);
    }
    configSetText(detail, configText('payment_total').replace('[amount]', display.current));
  } else detail?.remove();
  let balance = summary.querySelector('.joa-payment-balance-note');
  const segmented = Boolean(surface?.querySelector('#downpay-block.joa-payment-segments'));
  if (hasDeposit && segmented) {
    if (!balance) {
      balance = document.createElement('span');
      balance.className = 'joa-payment-balance-note';
      summary.querySelector('.joa-design-summary__options').before(balance);
    }
    configSetText(balance, configText('payment_balance').replace('[amount]', amount(total - due)));
  } else balance?.remove();
}
window.JoaPaymentSummary = { render: renderPaymentSummary };

// Shared by Quick Add and both cart editors; payment values remain app-owned.
function approvedModalPayment(surface) {
  surface?.querySelectorAll('.joa-quick-ring__payment').forEach(fieldset => {
    const first = fieldset.querySelector(':scope > label');
    const full = fieldset.querySelector(':scope > label:has(input[value=""])');
    if (full && first && full !== first) first.before(full);
  });
}
function approvedEngraving(form) {
  const text = configText;
  const engraving = form?.querySelector('joa-engraving');
  const button = engraving?.querySelector('.joa-engraving-trigger');
  if (!button) return;
  engraving.classList.add('joa-config-engraving');
  let content = button.querySelector('.joa-config-engraving-copy');
  if (!content) {
    content = document.createElement('span'); content.className = 'joa-config-engraving-copy';
    const icon = document.createElement('span'); icon.className = 'joa-config-icon'; icon.innerHTML = optionIcon('engraving');
    const title = document.createElement('span'); title.className = 'joa-config-title'; title.textContent = engraving.dataset.addLabel || text('config_engraving');
    const value = document.createElement('span'); value.className = 'joa-config-value';
    const chevron = document.createElement('span'); chevron.className = 'joa-config-chevron'; chevron.setAttribute('aria-hidden', 'true');
    content.append(icon, title, value, chevron); button.append(content);
  }
  const saved = engraving.querySelector('[data-engraving-property]');
  const value = engraving.summary?.() || (saved && !saved.disabled && saved.value ? `“${saved.value}”` : text('config_not_added'));
  configSetText(content.querySelector('.joa-config-value'), value);
  configSetAttr(button, 'aria-label', `${engraving.dataset.addLabel || text('config_engraving')}: ${value}`);
}

const instances = new WeakMap();
function create(container, copyNode, quick) {
let approved = false;
let copy = {};
try { copy = { ...JSON.parse(document.querySelector('[data-joa-global-option-copy]')?.textContent || '{}'), ...JSON.parse(copyNode?.textContent || '{}') }; } catch (_) {}
const text = key => copy[key] || key.replaceAll('_', ' ');
const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
const setAttr = (node, name, value) => { if (node.getAttribute(name) !== String(value)) node.setAttribute(name, String(value)); };
const selected = option => option.querySelector('input.mw-option__control[type="radio"]:checked');
const check = '<svg class="joa-choice-check" viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="m3 8 3 3 7-7"/></svg>';
function parseMaterial(label) {
if (/^(platinum|plat)$/i.test(label.trim())) return { purity: 'Platinum', color: 'White' };
const karat = label.match(/\b(\d{2})\s*k\b/i);
const color = /(?:2|two)[\s-]*tone/i.test(label) ? 'Two-tone' : label.match(/\b(yellow|white|rose)\b/i)?.[1];
if (!karat && color && /gold/i.test(label)) return { purity: 'Gold', color: color[0].toUpperCase() + color.slice(1).toLowerCase() };
if (!karat || !color) return null;
return { purity: `${karat[1]}K`, color: color[0].toUpperCase() + color.slice(1).toLowerCase() };
}
function materialChoices(option) {
return [...option.querySelectorAll('input.mw-option__control[type="radio"]')].map(input => {
const card = input.closest('.mw-option__value');
const label = card?.dataset.joaLabel || input.getAttribute('aria-label') || '';
return { input, label, ...parseMaterial(label) };
});
}
function materialUnavailable(choice) {
return choice.input.disabled || Boolean(choice.input.closest('.mw-option__value[hidden], .mw-option__value.mw-hidden'));
}
function chooseMaterial(option, value) {
const next = materialChoices(option).find(choice => choice.input.value === value);
if (next && !materialUnavailable(next) && !next.input.checked) next.input.click();
enhance();
}
function makeMaterialGroup(option, choices) {
const group = document.createElement('div');
group.className = 'joa-material-options';
group.style.setProperty('--joa-material-count', choices.length);
group.setAttribute('role', 'radiogroup');
group.setAttribute('aria-label', option.dataset.joaOptionName || text('purity_label'));
choices.forEach(choice => {
const button = document.createElement('button');
button.type = 'button'; button.className = 'joa-material-choice'; button.dataset.choice = choice.input.value;
button.setAttribute('role', 'radio'); button.setAttribute('aria-checked', 'false');
button.setAttribute('aria-label', choice.label); button.title = choice.label;
const swatch = document.createElement('span');
swatch.className = `joa-metal-swatch joa-metal-swatch--${choice.purity === 'Platinum' ? 'platinum' : choice.color.toLowerCase()}`;
swatch.textContent = choice.purity === 'Platinum' ? 'Pt' : choice.purity === 'Gold' ? '' : choice.purity;
swatch.setAttribute('aria-hidden', 'true'); button.append(swatch);
button.addEventListener('click', () => chooseMaterial(option, button.dataset.choice)); group.append(button);
});
group.addEventListener('keydown', event => {
if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
const buttons = [...group.querySelectorAll('button:not(:disabled)')], index = buttons.indexOf(event.target);
if (index < 0) return;
event.preventDefault();
const delta = ['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 1;
const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + delta + buttons.length) % buttons.length;
buttons[next].focus(); buttons[next].click();
});
return group;
}
function splitMaterial(option) {
const choices = materialChoices(option);
if (choices.length < 2 || choices.some(choice => !choice.purity || !choice.color)) {
option.querySelector('.joa-material-picker')?.remove(); option.classList.remove('joa-option--split-metal');
option.querySelector('.mw-option__container')?.removeAttribute('aria-hidden');
choices.forEach(choice => choice.input.removeAttribute('tabindex')); return;
}
const native = option.querySelector('.mw-option__container'); if (!native) return;
let ui = option.querySelector('.joa-material-picker');
const colorOrder = ['Yellow', 'White', 'Rose'];
const groupRank = choice => choice.purity === 'Platinum' ? 2 : choice.color === 'Two-tone' ? 1 : 0;
const ordered = [...choices].sort((a, b) => groupRank(a) - groupRank(b) || parseInt(a.purity, 10) - parseInt(b.purity, 10) || colorOrder.indexOf(a.color) - colorOrder.indexOf(b.color));
const signature = JSON.stringify(ordered.map(choice => [choice.input.value, choice.label, choice.purity, choice.color]));
if (!ui || ui.dataset.signature !== signature) {
ui?.remove(); ui = document.createElement('div'); ui.className = 'joa-material-picker'; ui.dataset.signature = signature;
ui.append(makeMaterialGroup(option, ordered));
native.parentElement.append(ui);
}
option.classList.add('joa-option--split-metal'); setAttr(native, 'aria-hidden', true);
choices.forEach(choice => { choice.input.tabIndex = -1; });
const focusChoice = ordered.find(choice => choice.input.checked && !materialUnavailable(choice)) || ordered.find(choice => !materialUnavailable(choice));
ui.querySelectorAll('.joa-material-choice').forEach(button => {
const choice = choices.find(item => item.input.value === button.dataset.choice);
button.disabled = !choice || materialUnavailable(choice);
setAttr(button, 'aria-checked', Boolean(choice?.input.checked));
button.tabIndex = !button.disabled && choice?.input === focusChoice?.input ? 0 : -1;
});
}
function decorateCards(option) {
if (!option.matches('.joa-option--clarity, .joa-option--diamond-size')) return;
// Use APO's single-choice contract so its selection and price state stay in sync.
option.classList.add('mw-option--disable-deselection');
option.querySelectorAll('.mw-option__value').forEach(card => {
const raw = card.dataset.joaLabel || '';
const parts = option.classList.contains('joa-option--clarity') ? raw.match(/^(VVS[12]|VS[12]|SI[12]|IF|FL)\s+(.+)$/i) : raw.match(/^([\d.]+)\s*(ct|carat)s?$/i);
if (!parts || card.querySelector('.joa-choice-copy')) return;
const label = card.querySelector('label'); if (!label) return;
const words = document.createElement('span'); words.className = 'joa-choice-copy'; words.setAttribute('aria-hidden', 'true');
const value = document.createElement('span'); value.className = 'joa-choice-value'; value.textContent = parts[1];
const unit = document.createElement('span'); unit.className = 'joa-choice-unit'; unit.textContent = option.classList.contains('joa-option--clarity') ? parts[2] : text('carat_unit');
words.append(value, unit); label.append(words);
if (option.classList.contains('joa-option--clarity')) label.insertAdjacentHTML('beforeend', check);
});
}
function optionText(option) {
const select = option.querySelector('select:not(.joa-option-quick-select)');
if (select) {
const label = select.selectedOptions[0]?.textContent?.trim() || '';
if (/please select/i.test(label)) return '';
if (option.classList.contains('joa-option--ring-size')) {
if (/not sure/i.test(label)) return text('size_to_confirm');
return `${text('ring_size')} ${label}`;
}
return label;
}
return selected(option)?.closest('.mw-option__value')?.dataset.joaLabel || '';
}
function prepareQuickOption(option) {
const title = option.querySelector('.mw-text--style-strong'), name = title?.textContent.trim() || '';
option.dataset.joaOptionName = name;
option.classList.toggle('joa-option--metal', /material|metal|gold colou?r/i.test(name));
option.classList.toggle('joa-option--diamond-size', /diamond size|(?:carat|ct\.?)\s*weight/i.test(name));
option.classList.toggle('joa-option--clarity', /clarity/i.test(name));
option.classList.toggle('joa-option--ring-size', /ring size/i.test(name));
option.classList.toggle('joa-option--band-width', /band width/i.test(name));
option.querySelectorAll('.mw-option__value[data-value-id]').forEach(card => {
const input = card.querySelector('input.mw-option__control');
const label = input?.getAttribute('aria-label') || card.querySelector('img[alt]')?.alt || card.dataset.joaLabel || '';
if (label) card.dataset.joaLabel = label.trim();
});
const heading = title?.closest('label.mw-label')?.querySelector(':scope > .mw-stack');
const main = heading?.querySelector(':scope > .mw-stack__item:first-child'); if (!main) return;
heading.classList.add('joa-option-heading-row'); main.classList.add('joa-option-heading-main');
let value = main.querySelector('.mw-accumulated-title');
if (!value) { value = document.createElement('span'); value.className = 'mw-text mw-accumulated-title'; main.append(value); }
value.classList.add('joa-option-heading-value'); value.classList.remove('mw-hidden');
const help = heading.querySelector('.mw-tooltip--icon')?.closest('.mw-stack__item');
if (help && help !== main) { help.classList.add('joa-option-heading-help'); if (help.parentElement !== main || help.nextElementSibling !== value) main.insertBefore(help, value); }
setText(value, optionText(option));
}
function displayValue(option, summary = false) {
  const raw = optionText(option);
  if (option.classList.contains('joa-option--ring-size')) {
    const select = option.querySelector('select:not(.joa-option-quick-select)');
    const size = select?.selectedOptions[0]?.textContent.trim() || '';
    const value = /not sure/i.test(size) ? text('config_confirm_later') : /please select/i.test(size) ? text('config_select_size') : size;
    return summary ? `${text('config_ring_size')}: ${value}` : value;
  }
  if (option.classList.contains('joa-option--diamond-size')) return raw.replace(/\s*ct\b/i, ' ct');
  if (option.classList.contains('joa-option--clarity')) return raw.replace(/^(VVS[12]|VS[12]|SI[12]|IF|FL)\s+(.+)$/i, '$1 / $2');
  return raw;
}
function optionKind(option) {
  if (option.classList.contains('joa-option--diamond-size')) return 'diamond';
  if (option.classList.contains('joa-option--clarity')) return 'clarity';
  if (option.classList.contains('joa-option--metal')) return 'metal';
  if (option.classList.contains('joa-option--ring-size')) return 'ring';
  return 'other';
}
function setExpanded(option, expanded) {
  option.dataset.joaExpanded = String(expanded);
}
function accordionRow(option) {
  const body = option.querySelector(':scope > .mw-stack, :scope > .mw-collapsible');
  if (!body) return;
  const kind = optionKind(option);
  const labels = { diamond: 'config_diamond_size', clarity: 'config_clarity_color', metal: 'config_metal', ring: 'config_ring_size' };
  const label = kind === 'diamond' && /(?:carat|ct\.?)\s*weight/i.test(option.dataset.joaOptionName) ? option.dataset.joaOptionName : labels[kind] ? text(labels[kind]).replaceAll('&amp;', '&') : option.dataset.joaOptionName;
  const select = kind === 'ring' ? option.querySelector('select:not(.joa-option-quick-select)') : null;
  if (select) setAttr(select, 'aria-label', label);
  let row = option.querySelector(':scope > .joa-config-row');
  if (!row) {
    row = document.createElement('div'); row.className = 'joa-config-row';
    const icon = document.createElement('span'); icon.className = 'joa-config-icon'; icon.innerHTML = optionIcon(kind);
    const title = document.createElement('span'); title.className = 'joa-config-title';
    const value = document.createElement('span'); value.className = 'joa-config-value';
    const chevron = document.createElement('span'); chevron.className = 'joa-config-chevron'; chevron.setAttribute('aria-hidden', 'true');
    const toggle = document.createElement('button'); toggle.type = 'button'; toggle.className = 'joa-config-toggle';
    toggle.id = `joa-toggle-${crypto.randomUUID()}`;
    if (!body.id) body.id = `joa-options-${crypto.randomUUID()}`;
    toggle.setAttribute('aria-controls', body.id);
    body.setAttribute('aria-labelledby', toggle.id);
    toggle.addEventListener('click', () => {
      setExpanded(option, option.dataset.joaExpanded !== 'true');
      accordionRow(option);
    });
    option.addEventListener('invalid', () => { setExpanded(option, true); accordionRow(option); }, true);
    row.append(icon, title, value, chevron, toggle); option.prepend(row);
    option.dataset.joaExpanded = String(kind === 'diamond');
  }
  const nativeHelp = option.querySelector('.joa-option-help-button');
  let help = row.querySelector('.joa-config-help');
  if (nativeHelp && !help) {
    help = document.createElement('button'); help.type = 'button'; help.className = 'joa-config-help';
    const mark = document.createElement('span'); mark.textContent = '?'; mark.setAttribute('aria-hidden', 'true'); help.append(mark);
    help.addEventListener('click', () => option.querySelector('.joa-option-help-button')?.click());
    row.append(help);
  }
  if (help && nativeHelp) {
    setAttr(help, 'aria-label', nativeHelp.getAttribute('aria-label'));
    setAttr(help, 'aria-controls', nativeHelp.getAttribute('aria-controls'));
    if (nativeHelp.hasAttribute('aria-haspopup')) setAttr(help, 'aria-haspopup', nativeHelp.getAttribute('aria-haspopup'));
    else help.removeAttribute('aria-haspopup');
    setAttr(help, 'aria-expanded', nativeHelp.getAttribute('aria-expanded') || 'false');
  }
  const error = option.querySelector('.mw-option__helptext.mw-text--style-negative:not(.mw-hidden):not([hidden])');
  const errorText = error?.textContent.trim() || '';
  if (errorText && option.dataset.joaErrorShown !== errorText) setExpanded(option, true);
  setAttr(option, 'data-joa-error-shown', errorText);
  const expanded = option.dataset.joaExpanded === 'true';
  const value = displayValue(option);
  setText(row.querySelector('.joa-config-title'), label);
  setText(row.querySelector('.joa-config-value'), value);
  const toggle = row.querySelector('.joa-config-toggle');
  setAttr(toggle, 'aria-label', `${label}${value ? ': ' + value : ''}`);
  setAttr(toggle, 'aria-expanded', expanded);
  body.hidden = !expanded;
  // APO can apply an inline display rule to ring sizing; keep it in sync.
  if (expanded) body.style.removeProperty('display');
  else body.style.setProperty('display', 'none', 'important');
  option.classList.add('joa-config-option');
}
function arrangeOptions() {
const options = [...container.querySelectorAll(':scope > .mw-option:not(.joa-birthstone-price-count)')];
if (quick) options.forEach(prepareQuickOption);
options.forEach(option => {
  const name = option.dataset.joaOptionName || '';
  if (/(?:carat|ct\.?)\s*weight/i.test(name)) option.classList.add('joa-option--diamond-size');
  if (/gold colou?r/i.test(name)) option.classList.add('joa-option--metal');
});
// APO inserts options asynchronously on product pages and in both popups.
// Every option set uses the shared layout, including jewelry without ring sizing.
approved = options.length > 0;
const rank = option => approved ? (option.classList.contains('joa-option--diamond-size') ? 0 : option.classList.contains('joa-option--clarity') ? 1 : option.classList.contains('joa-option--metal') ? 2 : option.classList.contains('joa-option--ring-size') ? 4 : 3) : option.classList.contains('joa-option--metal') ? 0 : option.classList.contains('joa-option--band-width') ? 1 : option.classList.contains('joa-option--diamond-size') ? 2 : option.classList.contains('joa-option--clarity') ? 3 : option.classList.contains('joa-option--ring-size') ? 5 : 4;
const ordered = [...options].sort((a, b) => rank(a) - rank(b));
ordered.forEach((option, index) => {
const current = container.querySelectorAll(':scope > .mw-option')[index];
if (current !== option) container.insertBefore(option, current);
const title = option.querySelector('.mw-text--style-strong');
if (!title) return;
const labelNodes = [...title.childNodes].filter(node => node.nodeType === Node.TEXT_NODE);
const raw = labelNodes.map(node => node.textContent).join('').replace(/[.:\s]+$/, '').trim();
const label = option.classList.contains('joa-option--metal') ? text('material_label') : raw;
if (labelNodes.length && label) {
if (labelNodes[0].textContent !== label) labelNodes[0].textContent = label;
labelNodes.slice(1).forEach(node => { if (node.textContent) node.textContent = ''; });
option.dataset.joaOptionName = label;
}
if (option.classList.contains('joa-option--band-width')) {
const count = option.querySelectorAll('.mw-option__value[data-value-id]:not([hidden]):not(.mw-hidden)').length;
option.style.setProperty('--joa-width-columns', count > 4 ? Math.ceil(count / 2) : Math.max(count, 1));
}
});
return ordered.filter(option => !option.classList.contains('mw-hidden') && !option.hidden);
}
function inlineSelector(option, main) {
if (!main || option.classList.contains('joa-option--ring-size')) return;
const inputs = [...option.querySelectorAll('input.mw-option__control[type="radio"]')];
if (inputs.length < 2) { main.querySelector('.joa-inline-selector')?.remove(); option.classList.remove('joa-option--inline-selector'); return; }
let wrap = main.querySelector('.joa-inline-selector');
if (!wrap) {
wrap = document.createElement('span'); wrap.className = 'joa-inline-selector';
const select = document.createElement('select'); select.className = 'joa-option-quick-select';
select.addEventListener('change', () => {
const input = [...option.querySelectorAll('input.mw-option__control[type="radio"]')].find(node => node.value === select.value);
if (input && !input.disabled && !input.checked) input.click();
enhance();
});
wrap.append(select); main.append(wrap);
}
option.classList.add('joa-option--inline-selector');
const select = wrap.querySelector('select'), current = inputs.find(input => input.checked)?.value || '';
const choices = inputs.map(input => ({value:input.value,label:input.closest('.mw-option__value')?.dataset.joaLabel || input.getAttribute('aria-label') || input.value,disabled:input.disabled || Boolean(input.closest('[hidden],.mw-hidden'))}));
const signature = JSON.stringify([choices, Boolean(current)]);
if (select.dataset.signature !== signature) {
select.replaceChildren();
if (!current) { const placeholder = new Option('Select', ''); placeholder.disabled = true; select.append(placeholder); }
choices.forEach(choice => { const item = new Option(choice.label, choice.value); item.disabled = choice.disabled; select.append(item); });
select.dataset.signature = signature;
}
setAttr(select, 'aria-label', `Change ${option.dataset.joaOptionName || 'option'}`);
if (select.value !== current) select.value = current;
let selectedCopy = wrap.querySelector('.joa-inline-selector-copy');
if (!selectedCopy) {
selectedCopy = document.createElement('span'); selectedCopy.className = 'joa-inline-selector-copy';
selectedCopy.setAttribute('aria-hidden', 'true'); wrap.prepend(selectedCopy);
}
setText(selectedCopy, select.selectedOptions[0]?.textContent || 'Select');
}
function optionHelp(option, main, kind, labelKey, buildContent) {
if (!main) return;
let holder = main.querySelector('.joa-option-heading-help');
if (!holder) { holder = document.createElement('div'); holder.className = 'mw-stack__item joa-option-heading-help'; main.append(holder); }
if (holder.querySelector('.joa-option-help-button')) return;
option.querySelectorAll('.joa-option-help-panel,.joa-clarity-help-panel').forEach(panel => panel.remove());
const button = document.createElement('button'); button.type = 'button'; button.className = 'joa-option-help-button';
button.id = `joa-option-help-button-${kind}-${crypto.randomUUID()}`;
button.setAttribute('aria-label', text(labelKey)); button.title = text(labelKey); button.setAttribute('aria-expanded', 'false');
const mark = document.createElement('span'); mark.className = 'joa-option-help-mark'; mark.textContent = '?'; mark.setAttribute('aria-hidden', 'true');
const label = document.createElement('span'); label.className = 'joa-option-help-label'; label.textContent = text('help_label'); label.setAttribute('aria-hidden', 'true');
button.append(mark, label);
const popup = !quick && container.closest('.product-information') && !container.closest('dialog,.mw-tingle');
const panel = document.createElement(popup ? 'dialog' : 'div'); panel.className = 'joa-option-help-panel';
panel.id = `joa-option-help-${kind}-${crypto.randomUUID()}`;
button.setAttribute('aria-controls', panel.id);
const setExpanded = expanded => {
button.setAttribute('aria-expanded', String(expanded));
option.querySelector('.joa-config-help')?.setAttribute('aria-expanded', String(expanded));
};
const close = () => { if (popup) panel.close(); else panel.hidden = true; setExpanded(false); };
if (popup) {
panel.classList.add('joa-option-help-dialog'); button.setAttribute('aria-haspopup', 'dialog');
const header = document.createElement('div'); header.className = 'joa-option-help-dialog__header';
const heading = document.createElement('h2'); heading.id = `${panel.id}-title`; heading.textContent = text(labelKey);
panel.setAttribute('aria-labelledby', heading.id);
const dismiss = document.createElement('button'); dismiss.type = 'button'; dismiss.className = 'joa-option-help-dialog__close'; dismiss.setAttribute('aria-label', text('close_help'));
dismiss.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>';
dismiss.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); close(); });
header.append(heading, dismiss);
const body = document.createElement('div'); body.className = 'joa-option-help-dialog__body'; buildContent(body); panel.append(header, body);
panel.addEventListener('close', () => { setExpanded(false); if (button.isConnected) (option.querySelector('.joa-config-help') || button).focus({ preventScroll: true }); });
panel.addEventListener('click', event => { const rect = panel.getBoundingClientRect(); if (event.target === panel && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close(); });
} else {
panel.hidden = true; panel.setAttribute('role', 'region'); panel.setAttribute('aria-labelledby', button.id); buildContent(panel);
}
button.addEventListener('click', event => {
event.preventDefault(); event.stopPropagation();
const opening = popup ? !panel.open : panel.hidden;
container.querySelectorAll('.joa-option-help-button[aria-expanded="true"]').forEach(other => {
other.setAttribute('aria-expanded', 'false');
other.closest('.mw-option')?.querySelector('.joa-config-help')?.setAttribute('aria-expanded', 'false');
const otherPanel = document.getElementById(other.getAttribute('aria-controls')); if (otherPanel?.matches('dialog[open]')) otherPanel.close(); else if (otherPanel) otherPanel.hidden = true;
});
if (popup) { if (opening) panel.showModal(); else close(); } else panel.hidden = !opening;
setExpanded(opening);
});
option.addEventListener('keydown', event => {
if (event.key === 'Escape' && (popup ? panel.open : !panel.hidden)) { event.preventDefault(); event.stopPropagation(); close(); (option.querySelector('.joa-config-help') || button).focus({ preventScroll: true }); }
});
holder.replaceChildren(button); option.append(panel);
}
function enhance() {
container.setAttribute('data-joa-option-design', '');
container.closest('form')?.setAttribute('data-joa-option-design', '');
const heading = container.querySelector('.joa-configurator-heading');
if (heading && !heading.dataset.joaDesignHeading) {
if (!quick) heading.id = 'joa-customize'; heading.tabIndex = -1;
const title = document.createElement('h2'); title.textContent = text('make_yours');
heading.replaceChildren(title); heading.dataset.joaDesignHeading = 'true';
}
const options = arrangeOptions();
if (heading && options.length) setText(heading.querySelector('h2'), text(options.some(option => option.classList.contains('joa-option--ring-size')) ? 'make_yours' : 'customize_design'));
options.forEach((option, index) => {
if (option.classList.contains('joa-option--ring-size')) {
  const select = option.querySelector('select:not(.joa-option-quick-select)');
  select?.style.setProperty('margin', '0', 'important');
  if (select) {
    const uncertain = [...select.options].find(choice => /not\s+sure/i.test(choice.textContent));
    if (uncertain) {
      const placeholders = [...select.options].filter(choice => /please\s+select/i.test(choice.textContent));
      const useDefault = !select.selectedOptions.length || placeholders.includes(select.selectedOptions[0]);
      if (useDefault) select.value = uncertain.value;
      if (uncertain.textContent !== text('config_confirm_later')) uncertain.textContent = text('config_confirm_later');
      placeholders.forEach(choice => choice.remove());
      if (useDefault) select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}
if (option.classList.contains('joa-option--clarity')) option.style.setProperty('--joa-clarity-count', option.querySelectorAll('input.mw-option__control[type="radio"]').length || 5);
const main = option.querySelector('.joa-option-heading-main');
if (main) {
main.style.setProperty('display', 'grid', 'important');
main.style.setProperty('column-gap', '6px', 'important');
[...main.childNodes].filter(node => node.nodeType === 3 && !node.textContent.trim()).forEach(node => node.remove());
let step = main.querySelector('.joa-option-step');
if (!step) { step = document.createElement('span'); step.className = 'joa-option-step'; step.setAttribute('aria-hidden', 'true'); main.prepend(step); }
setText(step, String(index + 1).padStart(2, '0')); if (!approved) inlineSelector(option, main);
}
if (option.classList.contains('joa-option--metal')) splitMaterial(option);
decorateCards(option);
if (option.classList.contains('joa-option--clarity')) {
optionHelp(option, main, 'clarity', 'clarity_help_label', panel => { const copy = document.createElement('p'); copy.textContent = text('clarity_help'); panel.append(copy); });
}
if (option.classList.contains('joa-option--diamond-size')) {
optionHelp(option, main, 'diamond', 'diamond_help_label', panel => {
const copy = document.createElement('p'); copy.textContent = text('diamond_help'); panel.append(copy);
const reference = document.createElement('p'); reference.className = 'joa-diamond-photo-reference';
const caption = document.createElement('em'); caption.textContent = text('diamond_photo_reference'); reference.append(caption); panel.append(reference);
});
}
if (option.classList.contains('joa-option--ring-size')) {
const guide = copyNode?.nextElementSibling;
if (guide?.matches('template[data-joa-ring-size-guide]')) optionHelp(option, main, 'ring', 'ring_help_label', panel => { panel.append(guide.content.cloneNode(true)); });
}
});
const form = container.closest('form');
if (approved) {
container.classList.add('joa-approved-configurator');
if (quick) container.closest('.joa-quick-ring,.mw-tingle')?.classList.add('joa-config-modal');
container.closest('.product-details')?.setAttribute('data-joa-config-details', '');
form?.setAttribute('data-joa-config-form', '');
options.forEach(accordionRow);
approvedEngraving(form);
}
const surface = container.closest('.joa-quick-ring,.mw-tingle,.product-information');
if (quick) approvedModalPayment(surface);
surface?.querySelectorAll('[data-joa-choose-size]').forEach(button => {
const target = [...container.querySelectorAll('.joa-option--diamond-size input.mw-option__control[type="radio"]')].find(input => Number.parseFloat(input.getAttribute('aria-label') || input.closest('[data-joa-label]')?.dataset.joaLabel) === Number(button.dataset.joaChooseSize));
button.disabled = !target || target.disabled;
button.setAttribute('aria-pressed', String(Boolean(target?.checked)));
if (button.dataset.joaSizeBound) return;
button.dataset.joaSizeBound = 'true';
button.addEventListener('click', () => {
const input = [...container.querySelectorAll('.joa-option--diamond-size input.mw-option__control[type="radio"]')].find(item => Number.parseFloat(item.getAttribute('aria-label') || item.closest('[data-joa-label]')?.dataset.joaLabel) === Number(button.dataset.joaChooseSize));
if (!input || input.disabled) return;
if (!input.checked) input.click();
enhance();
const option = input.closest('.mw-option');
if (!quick) { option.scrollIntoView({ block: 'center', behavior: 'auto' }); option.querySelector('.joa-option-quick-select')?.focus({ preventScroll: true }); }
});
});
const paymentNote = form?.querySelector('[data-quick-payment-note]');
if (paymentNote) setText(paymentNote, text(form.querySelector('input[name="selling_plan"]:checked')?.value ? 'deposit_note' : 'full_note'));
let summary = container.querySelector('.joa-design-summary') || form?.querySelector('.joa-design-summary');
if (!summary && options.length) {
summary = document.createElement('div'); summary.className = 'joa-design-summary'; summary.setAttribute('aria-live', 'polite'); summary.setAttribute('aria-atomic', 'true');
const label = document.createElement('span'); label.textContent = text('your_selection'); summary.append(label, document.createElement('p')); container.append(summary);
}
if (summary) {
const values = options.map(option => approved ? displayValue(option, true) : optionText(option)).filter(Boolean);
const priceHost = surface?.querySelector('product-price,.mw-product-info__price,.joa-quick-ring__price');
const baseDisplay = window.JoaPriceDisplay.read(priceHost);
// APO rewrites this visible price after each option change; normalize only its
// text nodes, preserving the app's markup and all configured price values.
if (quick && priceHost?.matches('.joa-quick-ring__price')) {
const walker = document.createTreeWalker(priceHost, NodeFilter.SHOW_TEXT);
for (let node = walker.nextNode(); node; node = walker.nextNode()) {
const parts = moneyParts(node.nodeValue);
if (parts) {
const formatted = formattedMoney(parts.amount, node.nodeValue, parts);
if (node.nodeValue !== formatted) node.nodeValue = formatted;
}
}
}
const quantity = quick ? Math.max(1, Number(form?.querySelector('[name="quantity"]')?.value) || 1) : 1;
const extra = (form?.querySelector('joa-birthstones')?.extraTotal?.() ?? (Number(surface?.dataset.joaBirthstoneTotal)||0)) * quantity;
const parts = moneyParts(baseDisplay?.current);
const display = extra && parts ? {...baseDisplay,current:formattedMoney(parts.amount+extra/100,baseDisplay.current,parts),compare:''} : baseDisplay;
const price = display?.current || '';
if (price) values.push(price);

summary.classList.toggle('joa-config-total', approved);
if (approved) approvedPayment(form, baseDisplay);
const paragraph = summary.querySelector('p');
const selections = (price ? values.slice(0, -1) : values).join(' · ');
const priceSeparator = selections ? (quick ? ' · ' : ' ') : '';
const summaryKey = JSON.stringify([selections, display]);
if (paragraph && (paragraph.dataset.joaSummary !== summaryKey || !paragraph.querySelector('.joa-design-summary__options') || (price && !paragraph.querySelector('.joa-design-summary__price')))) {
const selectionsNode = document.createElement('span');
selectionsNode.className = 'joa-design-summary__options';
if (approved) {
renderSelectionChips(selectionsNode, options.map(option => ({
kind: optionKind(option),
label: option.dataset.joaOptionName || configText('your_selection'),
value: displayValue(option, true)
})));
} else selectionsNode.textContent = selections;
paragraph.replaceChildren(selectionsNode);
if (price) {
if (priceSeparator && !approved) paragraph.append(document.createTextNode(priceSeparator));
const priceNode = document.createElement('span');
priceNode.className = 'joa-design-summary__price';
if (approved) paragraph.prepend(priceNode); else paragraph.append(priceNode);
}
paragraph.dataset.joaSummary = summaryKey;
}
if (price && paragraph) renderPaymentSummary(summary, display, form, surface, text(approved ? (options.some(option => option.classList.contains('joa-option--ring-size')) ? 'config_ring_total' : 'config_total') : 'your_selection'));
}
// Keep the reading order identical to the visual order. Place the product
// summary outside Downpay's rendered root so app updates cannot remove it.
if (summary && form) {
const quickPayment = form.querySelector('.joa-quick-ring__payment');
const downpayWrapper = form.querySelector('#downpay-block')?.closest('.shopify-app-block');
if (quickPayment) { const afterPayment = form.querySelector('[data-quick-payment-note]') || quickPayment; if (afterPayment.nextElementSibling !== summary) afterPayment.after(summary); }
else if (!quickPayment && downpayWrapper && summary.parentElement !== downpayWrapper) downpayWrapper.append(summary);
}
container.dispatchEvent(new CustomEvent('joa:options-designed', { bubbles: true }));
}
return { enhance };
}
window.JoaOptionDesign = {
icon: optionIcon,
renderSelectionChips,
stylePayment: approvedPayment,
styleModalPayment: approvedModalPayment,
styleEngraving: approvedEngraving,
enhance(container, copyNode, quick = false) {
if (!container) return;
let instance = instances.get(container);
if (!instance) { instance = create(container, copyNode, quick); instances.set(container, instance); }
instance.enhance();
}
};
document.addEventListener('joa:birthstones-change', event => { const form=event.detail?.form; if(form)window.JoaOptionDesign.enhance(form.querySelector('.mw-apo-container'),form.closest('.joa-quick-ring')?.querySelector('[data-joa-design-copy]')||document.querySelector('[data-joa-global-option-copy]'),Boolean(form.closest('.joa-quick-ring'))); });
const cartObservers = new WeakMap();
function enhanceCartOptions(container) {
if (!container.closest('.mw-tingle')) return;
const copy = document.querySelector('[data-joa-global-option-copy]');
window.JoaOptionDesign.enhance(container, copy, true);
const modal = container.closest('.mw-tingle');
modal.classList.add('joa-cart-options-modal');
let labels = {};
try { labels = JSON.parse(copy?.textContent || '{}'); } catch (_) {}
const box = modal.querySelector('.tingle-modal-box');
const close = modal.querySelector('.tingle-modal__close');
if (box && close && !box.querySelector('.joa-cart-editor-header')) {
const header = document.createElement('div'); header.className = 'joa-cart-editor-header';
const title = document.createElement('h2'); title.textContent = labels.edit_options || 'Edit your ring';
close.setAttribute('aria-label', labels.close_options || 'Close ring editor');
header.append(title, close); box.prepend(header);
}
const footer = modal.querySelector('.tingle-modal-box__footer');
if (footer && !footer.querySelector('.joa-completion-estimate') && window.JoaCompletionDate) {
  footer.append(window.JoaCompletionDate.create(labels.estimated_completion_date));
}
const submit = modal.querySelector('.tingle-modal-box__footer .btn--primary');
if (submit && submit.textContent !== labels.save_changes) submit.textContent = labels.save_changes || 'Save changes';
if (cartObservers.has(container)) return;
let pending = false;
const refresh = () => {
if (pending) return;
pending = true;
requestAnimationFrame(() => {
pending = false;
if (container.isConnected) window.JoaOptionDesign.enhance(container, copy, true);
});
};
container.addEventListener('change', refresh);
const observer = new MutationObserver(refresh);
observer.observe(container, { childList: true, subtree: true });
cartObservers.set(container, observer);
}
const modalObserver = new MutationObserver(records => {
for (const record of records) for (const node of record.addedNodes) {
if (!(node instanceof Element)) continue;
if (node.matches('.mw-apo-container')) enhanceCartOptions(node);
node.querySelectorAll('.mw-tingle .mw-apo-container').forEach(enhanceCartOptions);
}
});
modalObserver.observe(document.body, { childList: true, subtree: true });
document.querySelectorAll('.mw-tingle .mw-apo-container').forEach(enhanceCartOptions);
})();





